<template>
    <div id="takeoff">
        <screen ref='screen'></screen>
    </div>
</template>

<script>

import Screen from 'views/cdu/cduHeader/Screen'
import {initTakeoff} from 'utils/initPageData'

export default { 
    name: 'Takeoff',
    components: {
        Screen
    },
    data() {
        return {
            showData: [],

            // index会变成[1,2]
            index:[],
            page1: [
                [
                    ['TAKEOFF REF', ['','','']],
                    [1,2]
                ],
                [
                    [ 'FLAPS', 'V1' ], 
                    [ '□□°', '−−−' ] 
                ], 
                [ 
                    [ '26K N1', 'VR' ], 
                    [ '8.1/98.1', '−−−' ] 
                ],
                [ 
                    [ 'CG TRIM', 'V2' ], 
                    [ '−−.−%', '−−−' ] 
                ],
                [ 
                    [ '', 'GW / TOW' ], 
                    [ '', '' ] 
                ],
                [ 
                    [ 'RUNWAY', 'RWY REMAIN' ], 
                    [ '', '' ] 
                ],
                [ 
                    [ '', 'SELECT' ], 
                    [ '<PERF INIT', 'QRH OFF>' ] 
                ],
            ],
            page2:  [
                [
                    ['TAKEOFF REF',['','','']], 
                    [2,2]
                ],
                [
                    [ 'RW WIND', 'RW COND' ], 
                    [ '−−−°/−−−', 'DRY/WET/SK-R>' ] 
                ], 
                [ 
                    [ 'RW SLOPE/HDG', 'SEL/OAT' ], 
                    [ '−−.−%/', '−−−−/ +15℃' ] 
                ],
                [ 
                    [ '', '' ], 
                    [ '', '' ] 
                ],
                [ 
                    [ 'ACCEL HT', 'EO ACCEL HT' ], 
                    [ '1500AGL', '800AGL' ] 
                ],
                [ 
                    [ 'REDUCTION \xa0\xa0\xa0 \xa0\xa0\xa0 THR', '' ], 
                    [ '1500AGL \xa0\xa0\xa0 CLB', '' ] 
                ],
                [ 
                    [ '', 'CUTBACK' ], 
                    [ '<PERF INIT', 'ON/OFF' ] 
                ],
            ],
        }
    },
    methods: {
        initPage(){
            this.index = this.page1[0][1]
            this.showData = this['page'+ this.index[0]]
        },
        chgPage(){
            this.showData = this['page'+ this.index[0]]
        }
    },
    created() {
        this.initPage()
        initTakeoff(this)
    },
    watch: {
        'index': {
            handler(newV, oldV){
                initTakeoff(this)
            },
            deep: true,
            immediate: true
        }
    }
}
</script>

<style scoped>

</style>